import React from "react";
import CanvasWrapper from "../CanvasWrapper";
import MouseContainer from "../mousecontainer";
import { useParams } from "react-router-dom";


const Board = ({ contentLoading, setContentLoading }) => {
  return (
    <>
     <CanvasWrapper  contentLoading={contentLoading} setContentLoading={setContentLoading}/>
      {/* <BoardNav />
      <IconBar />
      <AntSideBar /> */}
    </>
  );
};

export default Board;
